import { AemEnergyLabelRenditions } from "@components/EnergyLabel/utils";
import { ECommerceProduct } from "@components/Product/ECommerce/eCommerce.types";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

const GPC_ENERGY_FEATURE_CODE_SUFFIX = "4.242";
const ONE_BY_TWO_XS_RENDITION = "250x500";
const ONE_BY_TWO_SM_RENDITION = "350x700";
const ONE_BY_TWO_MD_RENDITION = "480x960";
const ONE_BY_TWO_LG_RENDITION = "600x1200";

const HYBRIS_THUMBNAIL_RENDITION = "110x82";
const HYBRIS_MAIN_RENDITION = "440x330";
const HYBRIS_ZOOM_RENDITION = "800x600";
const HYBRIS_MAX_ZOOM_RENDITION = "1920x1440";

const EnergyLabelAdapter = (product: FullProductApiModel) => {
    const energyFeature = product.features
        .find(f => f.code.endsWith(GPC_ENERGY_FEATURE_CODE_SUFFIX))
        ?.featureValues.find(fv => fv.valid);

    const energyLabelLarge = product.energyLabels.at(0)?.medias.reduce(
        (acc, curr) => {
            if (curr.altText) {
                acc.altText = curr.altText;
            }
            switch (curr.format) {
                case ONE_BY_TWO_XS_RENDITION:
                case HYBRIS_THUMBNAIL_RENDITION:
                    acc.thumbnail = curr.url;
                    break;
                case ONE_BY_TWO_SM_RENDITION:
                case HYBRIS_MAIN_RENDITION:
                    acc.main = curr.url;
                    break;
                case ONE_BY_TWO_MD_RENDITION:
                case HYBRIS_ZOOM_RENDITION:
                    acc.zoom = curr.url;
                    break;
                case ONE_BY_TWO_LG_RENDITION:
                case HYBRIS_MAX_ZOOM_RENDITION:
                    acc.maxZoom = curr.url;
                    break;
            }
            return acc;
        },
        { altText: product.productTitle } as AemEnergyLabelRenditions,
    );

    return {
        energyLabel: energyFeature?.imageURL,
        energyLabelAltText:
            energyFeature?.formattedValue || product.productTitle,
        energyLabelLarge,
    };
};

export { EnergyLabelAdapter };
